import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const navItems = [
  { path: '/', icon: 'FiHome', label: 'Dashboard' },
  { path: '/demo', icon: 'FiCpu', label: 'Demo / How It Works' },
  { path: '/builder', icon: 'FiPlusSquare', label: 'Playlist Builder' },
  { path: '/rooms', icon: 'FiRadio', label: 'Listening Rooms' },
  { path: '/settings', icon: 'FiSliders', label: 'Preferences' },
];

export default function Sidebar() {
  return (
    <aside className="hidden md:flex flex-col w-64 bg-vinyl-900 border-r border-vinyl-700/50 h-full">
      <div className="p-6 flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-plasma to-aqua flex items-center justify-center shadow-[0_0_15px_rgba(255,0,255,0.3)]">
          <SafeIcon icon="FiHeadphones" className="text-white text-sm" />
        </div>
        <h1 className="font-display font-bold text-xl tracking-wider text-white">
          Sound<span className="text-plasma text-glow-plasma">Nest</span>
        </h1>
      </div>

      <nav className="flex-1 px-4 space-y-2 mt-4">
        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4 px-2">Menu</div>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 ${
                isActive
                  ? 'bg-vinyl-800 text-white shadow-[inset_2px_0_0_#00FFFF]'
                  : 'text-gray-400 hover:text-white hover:bg-vinyl-800/50'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="text-lg" />
            <span className="font-medium text-sm">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-6">
        <div className="glass-panel p-4 rounded-xl relative overflow-hidden group border-plasma/20">
          <h4 className="text-sm font-semibold text-white mb-1">Status</h4>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
            <span className="text-xs text-gray-400">Nodes Optimal</span>
          </div>
          <button className="w-full py-2 bg-vinyl-700 hover:bg-plasma hover:text-white border border-plasma/50 rounded-lg text-xs font-semibold transition-all duration-300 glow-plasma">
            System Log
          </button>
        </div>
      </div>
    </aside>
  );
}